module.exports = __webpack_public_path__ + "img/01_C_T.4281a56e.png";